import { combineReducers } from 'redux'

import sessionReducer, * as fromSession from './reducer.session'
import initialisationReducer, * as fromInitialisation from './reducer.initialisation'

export default combineReducers({
	session: sessionReducer,
	initialisation: initialisationReducer,
})

// State accessors

export const getSessionId = (state, key) => fromSession.getSessionId(state.session)
export const getInitialisationStatus = state => fromInitialisation.getInitialisationStatus(state.initialisation)

// State generators

export const createInitialState = session_id => {
	return {
		session: fromSession.createInitialState(session_id),
	}
}
